module.exports = __webpack_public_path__ + "static/media/play.4d0331dd.svg";